import { TFunction } from 'i18next';

import type { ConversationInventory } from '../services/inventory-service';
import { ConversationTask } from '../use-chat/use-chat.types';
import { VisualizationTable } from '../use-visualization-store/useVisualizationStore';
import { buildInventoryContent } from './buildInventoryContent';
import { BODY_STYLE, htmlNodes } from './htmlNodes';
import { markdownParser } from './markdownParser';

interface CopyResearchMessageArgs {
  task: ConversationTask;
  charts: Record<string, HTMLDivElement>;
  tables: Record<string, VisualizationTable>;
  inventory?: ConversationInventory;
  t: TFunction;
}

export const copyResearchMessage = async ({
  task,
  charts,
  tables,
  inventory,
  t,
}: CopyResearchMessageArgs) => {
  if (!task.states) {
    return;
  }

  let { htmlContent, plainContent } = task.states.reduce(
    (result, curr) => {
      result.plainContent += `\n\n## ${curr.title}\n\n`;
      result.htmlContent += htmlNodes.h2(curr.title);

      const processedHtmlContent = markdownParser({
        content: curr.content,
        charts,
        tables,
      });

      result.plainContent += curr.content;
      result.htmlContent += processedHtmlContent + '\n';
      return result;
    },
    {
      htmlContent: '',
      plainContent: '',
    }
  );

  const { html: inventoryHtml, text: inventoryText } = buildInventoryContent(
    t,
    inventory
  );

  plainContent += inventoryText;
  htmlContent += inventoryHtml;

  const clipboardData: Record<string, Blob> = {
    'text/plain': new Blob([plainContent.trim()], { type: 'text/plain' }),
    'text/html': new Blob(
      [
        `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <style>
          body { ${BODY_STYLE} }
        </style>
      </head>
      <body>
        ${htmlContent}
      </body>
      </html>
    `,
      ],
      { type: 'text/html' }
    ),
  };

  await navigator.clipboard.write([new ClipboardItem(clipboardData)]);
};
